import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Logout from '../subscribers/Logout';
import AdminLink from '../admin/subscribers/AdminLink'

export default class NavBar extends Component {
    render() {
        return (
            <header id="header">
                <Link to="/" className="logo">
                    <img src="img/logo.png" className="logo-light" alt=""/>
                </Link>
                <a href="#" className="mob-menu">
                    <span></span><span></span><span></span>
                </a>

                <nav className="navigation">
                    <ul>

                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li>
                            <Link to="/about">About</Link>
                        </li>

                        <li>
                            <Link to="/portfolio">Portfolio</Link>
                        </li>


                        <li>
                            <Link to="/blog">Blog</Link>
                        </li>

                        <li>
                            <Link to="/contact">Contacto</Link>
                        </li>

                        <AdminLink/>

                        <Logout/>

                    </ul>
                </nav>

            </header>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NavBar.js